

exports.__esModule = true;
exports.$ComponentRoute = exports.$Route = undefined;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _core = require('../core');

var _locale = require('../locale');

var _component = require('./component');

var _ng = require('./ng');

var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {

    childSpec: {},

    init: function init() {
        var _this = this;

        this.validate();

        this.url = '/' + (this.path || this.name);

        if (this.query) {
            this.url += '?' + this.query.join('&');
        }

        this.hasResolver = Boolean(this.resolve);

        var controller = this.controller = function ($scope) {
            $scope.route = _this;
            if ($scope.componentScope) {
                delete $scope.componentScope.view;
            }
        };

        if (this.get('resolve.action')) {
            this.controller = function ($scope, action) {
                _angular.$injector.invoke(controller, this, { $scope: $scope });
                if (action) {
                    _angular.$location.replace();
                    if (angular.isObject(action) && action.to && action.params) {
                        _uiRouter.$state.go(action.to, action.params);
                    } else {
                        _uiRouter.$state.go(action);
                    }
                }
            };
        }
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var routeName = this.constructor.name;

        if (!this.name && !this.path) {
            throw new Error(routeName + ' :: expected property \'path\'');
        }

        if (this.url) {
            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
        }

        if (this.query && !(this.query instanceof Array)) {
            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
        }

        if (this.controller) {
            // throw new Error(`${routeName} :: unexpected property 'controller'`);
        }

        if (this.resolve) {
            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
            }

            Object.keys(this.resolve).forEach(function (name) {
                if (name === 'data') {
                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
                } else if (name !== 'action') {
                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
                }
            });
        }

        if (this.template) {
            throw new Error(routeName + ' :: unexpected property \'template\'');
        }

        if (!this.directive && !this.resolve && !this.resolve.action) {
            throw new Error(routeName + ' :: expected property \'directive\'');
        }

        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
        }

        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
        }

        if (this.children) {
            this.children.forEach(function (childSpec) {

                if (!childSpec.route && !childSpec.name) {
                    throw new Error(routeName + ' :: child expected property \'route\'');
                }

                var ChildRoute = childSpec.route;
                var childName = childSpec.name || ChildRoute.name;

                if (!ChildRoute && childSpec.name) {
                    try {
                        ChildRoute = _angular.$injector.get(childSpec.name);
                    } catch (err) {
                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
                    }
                }

                if (!$Route.isChild(ChildRoute)) {
                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
                }
            });
        }
    },
    goto: function goto(route) {
        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
    },
    getDirective: function getDirective() {
        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
    },
    getDirectiveTag: function getDirectiveTag() {
        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
    },


    bootstrap: function bootstrap(defaultState, middleware) {
        var _this2 = this;

        return (0, _ng.$angularInvoke)(function () {

            // only bootstrap if not bootstrapped already
            var element = angular.element(document.body);
            if (!element.injector()) {
                angular.bootstrap(element, ['app']);
            }

            return _this2.load(defaultState, middleware);
        });
    },

    load: function load(defaultState, middleware) {

        defaultState = defaultState || this.defaultState;
        middleware = middleware || this.middleware;

        _logger.$logger.info('bootstrap_route', {
            route: this.path || this.name
        });

        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            event.preventDefault();

            _logger.$logger.error('state_not_found', {
                name: unfoundState.to,
                from: fromState.name,
                fromParams: fromParams,
                hash: window.location.hash
            });

            throw new Error('state_not_found: ' + unfoundState.to);
        });

        this.register();

        _uiRouter.$urlRouterProvider.otherwise(function () {
            return _logger.$logger.info('otherwise_after_bootstrap', {
                hash: window.location.hash
            });
        });

        this.runMiddleware(middleware).then(function () {

            var targetState = void 0,
                targetParams = void 0;

            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {

                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');

                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
            }

            _logger.$logger.info('initializing_route', {
                target: targetState,
                defaultState: defaultState,
                hash: window.location.hash
            });

            _angular.$location.replace();

            if (targetState) {
                if (_uiRouter.$state.get(targetState)) {
                    _logger.$logger.info('existing_state', {
                        stateName: targetState
                    });
                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                        // lib/js/security.js event listener handles auth required state changes
                        // and cancels transitions if user not authenticated
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: targetState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                }

                _logger.$logger.info('unknown_state', {
                    stateName: targetState
                });
            }

            if (_uiRouter.$state.get(defaultState)) {
                _logger.$logger.info('default_state', {
                    stateName: defaultState
                });
                return _uiRouter.$state.go(defaultState)['catch'](function (err) {
                    if (err.message === 'transition prevented') {
                        _logger.$logger.warn('transition_prevented', {
                            targetState: defaultState
                        });
                        return _core.$promise.resolve();
                    }
                    return _core.$promise.reject(err);
                });
            }

            throw new Error('Default state not found: ' + defaultState);
        })['catch'](function (err) {
            return _angular.$injector.get('$exceptionHandler')(err);
        });
    },

    runMiddleware: function runMiddleware(middleware) {

        _logger.$logger.info('middleware', {
            priority: _core.$util.map(middleware, function (method) {
                return method.name;
            }).join('|')
        });

        var promise = _core.$promise.resolve();

        angular.forEach(middleware, function (method) {
            promise = promise.then(function () {

                if (method.name) {
                    _logger.$logger.info('middleware_' + method.name);
                }

                return method();
            });
        });

        return promise;
    },

    register: function register() {
        var _this3 = this;

        this.template = this.constructTemplate(this.childAttributes || {});

        this.absolutePath = this.path || this.name;

        if (this.parent) {
            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
        }

        if (!_uiRouter.$state.get(this.absolutePath)) {
            _uiRouter.$stateProvider.state(this.absolutePath, this);
        }

        angular.forEach(this.children, function (childSpec) {

            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);

            var childRoute = new ChildRoute({
                parent: _this3,
                childSpec: childSpec,
                childAttributes: childSpec.attributes
            });

            childRoute.register();
        });
    },

    /**
     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
     * '<xo-add-bank/>'.
     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
     *
     * @param attributes - A map of name value pairs - {name: value}.
     * @returns {string}
     */
    constructTemplate: function constructTemplate(attributes) {
        var self = this;

        if (!self.directive) {
            return;
        }

        attributes['component-route'] = 'route';

        if (this.parent) {
            attributes['export'] = 'view';
        }

        var tag = this.getDirectiveTag();

        var paramString = '';

        angular.forEach(attributes, function (value, key) {
            paramString += ' ' + key + '="' + value + '"';
        });

        return '<div ' + tag + ' ' + paramString + '></div>';
    }
});

_uiRouter.$stateProvider.state('default', {
    auth: false
});

$Route.reopenClass({
    render: function render() {

        _core.$Model.clearCache();
        _core.$Api.clearCache();

        _core.$event.emit('$resetState');
        (0, _locale.$flushContent)();

        _core.$loader.reset();

        _uiRouter.$state.go('default');

        setTimeout.flush();

        var $scope = _angular.$rootScope.$new();

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);

        var element = (0, _angular.$compile)('<div><ui-view></ui-view></div>')($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            _core.$loader.reset();
            _core.$Model.clearCache();
            _core.$Api.clearCache();
        }));

        var route = new this();
        route.bootstrap();

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        return element;
    },


    assertActive: function assertActive() {
        assert(_uiRouter.$state.current instanceof this, 'Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
    }
});

function getPageTitle(stateName) {

    var state = _uiRouter.$state.get(stateName);

    if (!state) {
        return;
    }

    if (state.titleContent) {
        return _locale.$locale.content.get(state.titleContent);
    }
}

function changePageTitle() {

    document.documentElement.setAttribute('lang', _locale.$locale.lang);

    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
        return;
    }

    var fullStateTitle = [];

    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {

        var stateName = [a, b].filter(Boolean).join('.');
        var stateTitle = getPageTitle(stateName);

        if (stateTitle) {
            fullStateTitle.push(stateTitle);
        }

        return stateName;
    }, null);

    document.title = _core.$util.unique(fullStateTitle).join(' - ');
}

_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);

var $ComponentRoute = exports.$ComponentRoute = $Route;

angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;

_angular.$location;

_angular.$injector;

_angular.$compile;

_uiRouter.$state;

_uiRouter.$stateProvider;

_uiRouter.$urlRouterProvider;

_logger.$logger;

_core.$config;

_core.$Class;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_core.$loader;

_locale.$locale;

_locale.$flushContent;

_component.$Component;

_ng.$cleanRootScope;

_ng.$once;

_ng.$angularInvoke;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/ng/route.js
// module id = ./components/squid/dist/ng/route.js
// module chunks = 1